import { IBlackBox } from "@/api/AppApi/common-interfaces/api-enums";
import { IResultStamp } from "@/api/AppApi/common-interfaces/IResultStamp";
import { IGetCartResult } from "../../cart/interfaces/cart-interfaces";
import { IHomeComponentType } from "../../home/interfaces/IGetHome";
import { IMobileFields } from "../../order/interfaces/order-interfaces";

export interface IKeyValue {
  key: string;
  value: string;
  meta?: { code?: string };
}
export enum FieldTypes {
  address_types = "address_types",
  checkbox = "checkbox",
  date = "date",
  date_time = "date_time",
  email = "email",
  map = "map",
  multi_select = "multi_select",
  phone = "phone",
  mobile = "mobile",
  radio_buttons = "radio_buttons",
  select = "select",
  text = "text",
  number = "number",
  password = "password", //not from backend
  textarea = "textarea",
  time = "time",
  multi_file = "multi_file",
  file = "file",
  select_one_dropdown = "select_one_dropdown ",
}
export enum FieldSectionTypes {
  address = "address",
  customer = "customer",
}
export interface IField {
  type: "field";
  configurations: {
    key: string;
    title: string;
    description?: string;
    section: FieldSectionTypes | null;
    type: FieldTypes;
    is_required: boolean;
    is_extra: boolean;
    hint: string;
    multi_lang: boolean;
    parent_key: string | null;
    options_url: string | null;
    placeholder?: string;
    hideLabel?: boolean;
    sortable?: number;
  };
  value: any | null;
  data: IKeyValue[];
}
export interface IGetFields extends IResultStamp {
  result?: { builder: IField[]; data?: any };
}
export interface IGetAddress extends IResultStamp {
  result?: {
    builder: IField[];
    data: {
      address: string;
      address_name: string;
      area_id: number;
      area_name: string;
      city_id: number;
      city_name: string;
      contact_name: string;
      country_id: number;
      country_name: string;
      id: number;
      is_default: boolean;
      location: { lat: number; lng: number };
      mobile: string;
      other_address: string;
      other_inputs: any;
    };
  };
}
export interface IGetProfile extends IResultStamp {
  result?: {
    builder: IField[];
    data: {
      avatar: string;
      email: string;
      id: number;
      is_email_verified: boolean;
      is_mobile_verified: boolean;
      mobile: string;
      mobile_fields: IMobileFields | null;
      name: string;
      other_inputs: { [x: string]: string | null };
      registered_at: string;
    };
  };
}
export interface IGetFromURLParams {
  url: string | null;
  parentName: string | null;
  parentKey: string | null;
}
export interface IGetFromURL extends IResultStamp {
  result: IKeyValue[];
}

export interface ICheckoutResultData {
  address_fields: IField[];
  cart: IGetCartResult;
  extra_customer_fields: IField[];
  main_customer_fields: IField[];
}
export interface ICheckoutBuilder {
  builder: Array<IHomeComponentType | IBlackBox>;
  data: ICheckoutResultData;
}
export interface IGetCheckoutBuilder extends IResultStamp {
  result: ICheckoutBuilder;
}
export interface IGetApplicationParams {
  application_type_id: number | null;
  student_id: number;
  academic_year_id?: number;
}

export interface IGetContactUsBuilder extends IResultStamp {
  result: {
    builder: Array<IHomeComponentType | IBlackBox>;
    title: string;
    data: null;
  };
}
